import {
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { ErrorMsgComponent } from '@fitness-force/errors';

@Component({
  selector: 'freeze-comments',
  templateUrl: './freeze-comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    InputTextModule,
    ErrorMsgComponent,
  ],
})
export class FreezeCommentsComponent {
  readonly formGroup = input.required<UntypedFormGroup>();
  readonly freezeV2Flow = input<boolean>(false);
  readonly isRescheduleMode = input<boolean>(false);
  readonly isStopMode = input<boolean>(false);
  readonly isCancelMode = input<boolean>(false);

  get isSimpleCommentMode(): boolean {
    return (
      this.isRescheduleMode() || this.isStopMode() || this.isCancelMode()
    );
  }

  get showFullComments(): boolean {
    return (
      this.freezeV2Flow() &&
      !this.isRescheduleMode() &&
      !this.isStopMode() &&
      !this.isCancelMode()
    );
  }

  get showLegacyComment(): boolean {
    return !this.freezeV2Flow() || this.isRescheduleMode();
  }

  get clientVisibleControl() {
    return this.formGroup().controls['clientVisibleComments'] ?? null;
  }

  get internalCommentsControl() {
    return this.formGroup().controls['internalComments'] ?? null;
  }

  get commentControl() {
    return this.formGroup().controls['comment'] ?? null;
  }
}
